import { useContext } from 'react'
import { DomainConfigContext } from '../contexts/DomainConfigContext'

export const useDomainConfigContext = () => {
  return useContext(DomainConfigContext)
}
